<ion-header>
    <ion-toolbar color="dark">
        <ion-title *ngIf="_params.header" [innerHTML]="_params.header"></ion-title>
        <ion-buttons slot="end" *ngIf="_close">
            <ion-button uppDataid="modal-alert-close-button" (click)="OnClose()">
                <ion-icon slot="icon-only" name="close-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>
<ion-content color="light">
    <p *ngIf="_params.message" [innerHTML]="_params.message"></p>

    <ion-list [attr.data-id]="'modal-alert-content'">
        <ng-container *ngFor="let _input of _params.inputs">
            <ion-item class="input" lines="none" *ngIf="IsText(_input)">
                <upp-modal-input [attr.data-id]="'modal-alert-input-text'" 
                    [type]="_input.type" 
                    [placeholder]="_input.placeholder" 
                    [value]="_input.value" 
                    (Changed)="OnTextChange($event, _input)"
                ></upp-modal-input>
            </ion-item>
    
            <ion-item class="check" *ngIf="IsCheck(_input)" lines="none">
                <ion-checkbox [attr.data-id]="'modal-alert-check-' + normalize(_input.label)" 
                    slot="start" 
                    [value]="_input.value" 
                    (ionChange)="OnCheckChange($event, _input)"
                ></ion-checkbox>
                <ion-label>
                    {{_input.label}}
                </ion-label>
            </ion-item>

            <ng-container *ngIf="_input.type === 'radiogroup'" lines="none">        
                <ion-radio-group [attr.data-id]="'modal-alert-input-radiogroup'" *ngIf="IsRadio(_input)" [value]="_data[_input.name]" (ionChange)="OnRadioChange($event, _input)">
                    <ng-container *ngFor="let _option of _params.inputs">
                        <ion-item *ngIf="_option.type === 'radiobutton' && _option.name === _input.name" lines="none">
                            <ion-label>
                                {{_option.label}}
                            </ion-label>
                            <ion-radio [attr.data-id]="'modal-alert-radio-' + normalize(_option.label)" 
                                [value]="_option.value"
                            ></ion-radio>
                        </ion-item>    
                    </ng-container>
                </ion-radio-group>
            </ng-container>    
        </ng-container>                
    </ion-list>

    <div class="form-buttons">
        <ng-container *ngFor="let _button of _params.buttons">
            <ion-button [attr.data-id]="'modal-alert-button-' + normalize(_button.text)" fill="clear" color="primary" (click)="_button.handler(_data)" [disabled]="_button['check'] && !_button['check'](_data)">{{_button.text}}</ion-button>
        </ng-container>
        <div style="clear:both; height:5px"></div>    
    </div>
</ion-content>